/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemorySuggestionControllerFindAllQueryResponse, AgentMemorySuggestionControllerFindAllQueryParams, AgentMemorySuggestionControllerFindAll401, AgentMemorySuggestionControllerFindAll403 } from "../../models/agentMemorySuggestionsController/AgentMemorySuggestionControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agentMemorySuggestionControllerFindAll } from "../../clients/agent-memory-suggestionsService/agentMemorySuggestionControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agentMemorySuggestionControllerFindAllQueryKey = (params: AgentMemorySuggestionControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/agent-memory-suggestions'
}, ...(params ? [params] : [])] as const;
export type AgentMemorySuggestionControllerFindAllQueryKey = ReturnType<typeof agentMemorySuggestionControllerFindAllQueryKey>;
export function agentMemorySuggestionControllerFindAllQueryOptions(params?: AgentMemorySuggestionControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agentMemorySuggestionControllerFindAllQueryKey(params);
  return queryOptions<AgentMemorySuggestionControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemorySuggestionControllerFindAll401 | AgentMemorySuggestionControllerFindAll403>, AgentMemorySuggestionControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agentMemorySuggestionControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List pending agent memory suggestions
 * {@link /api/v1/agent-memory-suggestions}
 */
export function useAgentMemorySuggestionControllerFindAll<TData = AgentMemorySuggestionControllerFindAllQueryResponse, TQueryData = AgentMemorySuggestionControllerFindAllQueryResponse, TQueryKey extends QueryKey = AgentMemorySuggestionControllerFindAllQueryKey>(params?: AgentMemorySuggestionControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<AgentMemorySuggestionControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemorySuggestionControllerFindAll401 | AgentMemorySuggestionControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agentMemorySuggestionControllerFindAllQueryKey(params);
  const query = useQuery({
    ...agentMemorySuggestionControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AgentMemorySuggestionControllerFindAll401 | AgentMemorySuggestionControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}